(function() {
  var ATTRIBUTE_FALLBACK = 'Requested Delivery Date';
  var INITIALIZED = 'deliveryDatePickerInitialized';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) {
      return null;
    }

    var parts = value.split('-').map(Number);
    return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
  }

  function formatIsoDate(date) {
    return [
      date.getUTCFullYear(),
      pad(date.getUTCMonth() + 1),
      pad(date.getUTCDate())
    ].join('-');
  }

  function formatSlashDate(isoDate) {
    var date = parseIsoDate(isoDate);
    if (!date) {
      return isoDate || '';
    }

    return [
      pad(date.getUTCMonth() + 1),
      pad(date.getUTCDate()),
      date.getUTCFullYear()
    ].join('/');
  }

  function normalizeAttributeDate(value) {
    if (!value) {
      return '';
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    var match = String(value).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) {
      return '';
    }

    return [
      match[3],
      pad(match[1]),
      pad(match[2])
    ].join('-');
  }

  function formatFlatpickrDate(date) {
    return [
      date.getFullYear(),
      pad(date.getMonth() + 1),
      pad(date.getDate())
    ].join('-');
  }

  function addDays(date, days) {
    var nextDate = new Date(date.getTime());
    nextDate.setUTCDate(nextDate.getUTCDate() + days);
    return nextDate;
  }

  function parseBlockedDays(value) {
    return (value || '')
      .split(',')
      .map(function(day) { return parseInt(day, 10); })
      .filter(function(day) { return !Number.isNaN(day); });
  }

  function parseBlackoutDates(value) {
    return (value || '')
      .split(/[\s,]+/)
      .map(function(date) { return date.trim(); })
      .filter(function(date) { return /^\d{4}-\d{2}-\d{2}$/.test(date); });
  }

  function parseCutoff(value) {
    var match = String(value || '16:00').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) {
      return { hour: 16, minute: 0 };
    }

    return {
      hour: Math.min(parseInt(match[1], 10), 23),
      minute: Math.min(parseInt(match[2], 10), 59)
    };
  }

  function getShopNow(timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      hourCycle: 'h23'
    });

    var parts = formatter.formatToParts(new Date()).reduce(function(acc, part) {
      acc[part.type] = part.value;
      return acc;
    }, {});

    return {
      date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day))),
      hour: Number(parts.hour),
      minute: Number(parts.minute)
    };
  }

  function getRuleDates(config) {
    var shopNow = getShopNow(config.timeZone);
    var cutoff = parseCutoff(config.cutoffTime);
    var afterCutoff = shopNow.hour > cutoff.hour || (shopNow.hour === cutoff.hour && shopNow.minute >= cutoff.minute);
    var leadDays = config.leadTimeDays + (afterCutoff ? 1 : 0);
    var minDate = addDays(shopNow.date, leadDays);
    var maxDate = addDays(shopNow.date, config.maxDays);

    return {
      minDate: minDate,
      maxDate: maxDate,
      minIso: formatIsoDate(minDate),
      maxIso: formatIsoDate(maxDate)
    };
  }

  function cartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root + 'cart/update.js';
  }

  function getCartUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart) {
      return window.theme.routes.cart;
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function updateCartAttribute(attributeName, value) {
    var attributes = {};
        attributes[attributeName] = value ? formatSlashDate(value) : '';

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Cart attribute save failed.');
      }

      return response.json();
    });
  }

  function readCartAttribute(attributeName) {
    return fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Cart read failed.');
        }

        return response.json();
      })
      .then(function(cart) {
        return cart.attributes ? normalizeAttributeDate(cart.attributes[attributeName]) : '';
      });
  }

  function Picker(element) {
    this.element = element;
    this.attributeName = element.dataset.attributeName || ATTRIBUTE_FALLBACK;
    this.asapButton = element.querySelector('[data-delivery-asap]');
    this.scheduleButton = element.querySelector('[data-delivery-schedule]');
    this.panel = element.querySelector('[data-delivery-panel]');
    this.input = element.querySelector('[data-delivery-date-input]');
    this.confirmation = element.querySelector('[data-delivery-confirmation]');
    this.error = element.querySelector('[data-delivery-error]');
    this.clearButton = element.querySelector('[data-delivery-clear]');
    this.form = element.closest('form');
    this.checkoutButton = this.form ? this.form.querySelector('[name="checkout"]') : null;
    this.savedIso = normalizeAttributeDate(element.dataset.currentDate || '');
    this.selectedIso = this.savedIso;
    this.mode = this.selectedIso ? 'schedule' : 'asap';
    this.isSaving = false;
    this.hasSaveError = false;
    this.keepCalendarOpenUntil = 0;
    this.config = {
      timeZone: element.dataset.shopTimeZone || 'America/New_York',
      leadTimeDays: parseInt(element.dataset.leadTimeDays || '4', 10),
      cutoffTime: element.dataset.cutoffTime || '16:00',
      maxDays: parseInt(element.dataset.maxDays || '60', 10),
      blockedDays: parseBlockedDays(element.dataset.blockedDays),
      blackoutDates: parseBlackoutDates(element.dataset.blackoutDates)
    };
    this.ruleDates = getRuleDates(this.config);
    this.blackoutSet = new Set(this.config.blackoutDates);
    this.blockedDaySet = new Set(this.config.blockedDays);
    this.isRebuy = !!element.closest('[data-rebuy-cart-anchor], .rebuy-cart');

    this.init();
  }

  Picker.prototype.init = function() {
    if (!this.input || !this.asapButton || !this.scheduleButton) {
      return;
    }

    this.bindEvents();
    this.initCalendar();
    this.render();
    this.syncFromCart();
  };

  Picker.prototype.bindEvents = function() {
    this.asapButton.addEventListener('click', this.clear.bind(this));
    this.scheduleButton.addEventListener('pointerdown', function(event) {
      event.preventDefault();
    });
    this.scheduleButton.addEventListener('click', this.openSchedule.bind(this));

    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.clear.bind(this));
    }

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this), true);
    } else {
      this.rebuyRoot = this.element.closest('.rebuy-cart') || document;
      this.rebuyRoot.addEventListener('click', this.onRebuyCheckoutClick.bind(this), true);
    }
  };

  Picker.prototype.initCalendar = function() {
    if (!window.flatpickr) {
      this.input.type = 'date';
      this.input.min = this.ruleDates.minIso;
      this.input.max = this.ruleDates.maxIso;
      this.input.addEventListener('change', function(event) {
        this.selectDate(event.target.value);
      }.bind(this));
      return;
    }

    this.calendar = window.flatpickr(this.input, {
      inline: false,
      appendTo: document.body,
      positionElement: this.scheduleButton,
      disableMobile: true,
      clickOpens: false,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'l, F j',
      defaultDate: this.selectedIso || null,
      minDate: this.ruleDates.minIso,
      maxDate: this.ruleDates.maxIso,
      disable: [function(date) {
        return !this.isSelectable(formatFlatpickrDate(date));
      }.bind(this)],
      onChange: function(selectedDates, dateStr) {
        this.selectDate(selectedDates[0] ? formatFlatpickrDate(selectedDates[0]) : dateStr);
      }.bind(this),
      onReady: function(selectedDates, dateStr, instance) {
        instance.calendarContainer.classList.add('delivery-date-picker__calendar');
        instance.calendarContainer.setAttribute('tabindex', '-1');
      }.bind(this),
      onOpen: function() {
        window.setTimeout(this.keepCalendarInViewport.bind(this), 0);
      }.bind(this),
      onClose: function() {
        if (this.mode !== 'schedule' || this.selectedIso || Date.now() > this.keepCalendarOpenUntil) {
          return;
        }

        window.setTimeout(function() {
          if (this.mode === 'schedule' && !this.selectedIso && this.calendar) {
            this.calendar.open();
            this.keepCalendarInViewport();
          }
        }.bind(this), 120);
      }.bind(this),
      onMonthChange: function() {
        window.setTimeout(this.keepCalendarInViewport.bind(this), 0);
      }.bind(this),
      onYearChange: function() {
        window.setTimeout(this.keepCalendarInViewport.bind(this), 0);
      }.bind(this)
    });
  };

  Picker.prototype.keepCalendarInViewport = function() {
    if (!this.calendar || !this.calendar.calendarContainer) {
      return;
    }

    var calendar = this.calendar.calendarContainer;
    var rect = calendar.getBoundingClientRect();
    var gutter = 12;
    var currentLeft = parseFloat(calendar.style.left || '0');

    if (rect.right > window.innerWidth - gutter) {
      calendar.style.left = Math.max(gutter, currentLeft - (rect.right - window.innerWidth + gutter)) + 'px';
    }

    rect = calendar.getBoundingClientRect();
    currentLeft = parseFloat(calendar.style.left || '0');
    if (rect.left < gutter) {
      calendar.style.left = (currentLeft + (gutter - rect.left)) + 'px';
    }
  };

  Picker.prototype.syncFromCart = function() {
    readCartAttribute(this.attributeName)
      .then(function(value) {
        if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
          this.savedIso = value;
          this.selectedIso = value;
          this.mode = 'schedule';
          if (this.calendar) {
            this.calendar.setDate(value, false);
          } else {
            this.input.value = value;
          }
          this.render();
        }
      }.bind(this))
      .catch(function() {});
  };

  Picker.prototype.isSelectable = function(isoDate) {
    var date = parseIsoDate(isoDate);
    if (!date) {
      return false;
    }

    return isoDate >= this.ruleDates.minIso &&
      isoDate <= this.ruleDates.maxIso &&
      !this.blockedDaySet.has(date.getUTCDay()) &&
      !this.blackoutSet.has(isoDate);
  };

  Picker.prototype.openSchedule = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
    }

    this.mode = 'schedule';
    this.clearError();
    this.render();

    if (this.calendar) {
      this.keepCalendarOpenUntil = Date.now() + 900;
      window.setTimeout(function() {
        this.calendar.open();
        this.keepCalendarInViewport();
      }.bind(this), 180);
    } else {
      this.input.focus();
    }
  };

  Picker.prototype.selectDate = function(isoDate) {
    if (!this.isSelectable(isoDate)) {
      this.showError('Please choose an available requested delivery date.', false);
      return;
    }

    this.clearError();
    this.mode = 'schedule';
    this.selectedIso = isoDate;
    this.save(isoDate);
    this.resetMobileFocus();
  };

  Picker.prototype.resetMobileFocus = function() {
    if (this.calendar) {
      this.calendar.close();
    }

    if (this.input) {
      this.input.blur();
    }

    if (this.calendar && this.calendar.altInput) {
      this.calendar.altInput.blur();
    }

    if (document.activeElement && document.activeElement !== document.body && document.activeElement.blur) {
      document.activeElement.blur();
    }

    if (this.calendar && this.calendar.calendarContainer) {
      this.calendar.calendarContainer.focus({ preventScroll: true });
    }
  };

  Picker.prototype.clear = function() {
    if (this.isSaving) {
      return;
    }

    if (!this.savedIso) {
      this.mode = 'asap';
      this.selectedIso = '';
      this.clearError();
      this.clearCalendar();
      this.render();
      return;
    }

    this.mode = 'asap';
    this.selectedIso = '';
    this.clearError();
    this.clearCalendar();
    this.render();

    this.save('').then(function() {
      this.mode = 'asap';
      this.selectedIso = '';
      this.clearError();
      this.clearCalendar();
      this.render();
    }.bind(this));
  };

  Picker.prototype.clearCalendar = function() {
    if (this.calendar) {
      this.calendar.clear(false);
    } else {
      this.input.value = '';
    }
  };

  Picker.prototype.save = function(value) {
    this.isSaving = true;
    this.hasSaveError = false;
    this.render();

    return updateCartAttribute(this.attributeName, value)
      .then(function() {
        this.savedIso = value;
        this.selectedIso = value;
        this.isSaving = false;
        this.clearError();
        this.render();
      }.bind(this))
      .catch(function() {
        this.isSaving = false;
        this.showError('We could not save your requested delivery date. Please retry or clear the date before checkout.', true);
        this.render();
      }.bind(this));
  };

  Picker.prototype.showError = function(message, shouldBlock) {
    this.hasSaveError = !!shouldBlock;
    if (this.error) {
      this.error.textContent = message;
      this.error.hidden = false;
    }
  };

  Picker.prototype.clearError = function() {
    this.hasSaveError = false;
    if (this.error) {
      this.error.hidden = true;
      this.error.textContent = '';
    }
  };

  Picker.prototype.shouldBlockCheckout = function() {
    return this.mode === 'schedule' && !!this.selectedIso && (this.isSaving || this.hasSaveError || this.savedIso !== this.selectedIso);
  };

  Picker.prototype.onSubmit = function(event) {
    if (!this.shouldBlockCheckout()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.showError('Please wait for your requested delivery date to save, or clear it to ship ASAP.', true);
    if (this.checkoutButton) {
      this.checkoutButton.classList.remove('btn--loading');
    }
  };

  Picker.prototype.getRebuyCheckoutTargets = function() {
    var root = this.rebuyRoot || document;
    return root.querySelectorAll([
      '[data-rebuy-component="checkout-area"] .rebuy-cart__checkout-button',
      '[data-rebuy-component="checkout-area"] .rebuy-cart__view-cart-button',
      '[data-rebuy-cart-additional-checkout-buttons] button',
      '[data-rebuy-cart-additional-checkout-buttons] a'
    ].join(','));
  };

  Picker.prototype.onRebuyCheckoutClick = function(event) {
    var target = event.target.closest([
      '[data-rebuy-component="checkout-area"] .rebuy-cart__checkout-button',
      '[data-rebuy-component="checkout-area"] .rebuy-cart__view-cart-button',
      '[data-rebuy-cart-additional-checkout-buttons] button',
      '[data-rebuy-cart-additional-checkout-buttons] a'
    ].join(','));

    if (!target || !this.shouldBlockCheckout()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.showError('Please wait for your requested delivery date to save, or clear it to ship ASAP.', true);
  };

  Picker.prototype.render = function() {
    var isScheduled = this.mode === 'schedule';
    var isBlocking = this.shouldBlockCheckout();

    this.element.classList.toggle('is-saving', this.isSaving);
    this.element.classList.toggle('is-blocking', isBlocking);
    this.asapButton.classList.toggle('is-active', !isScheduled);
    this.scheduleButton.classList.toggle('is-active', isScheduled);
    this.panel.hidden = !isScheduled;
    if (this.clearButton) {
      this.clearButton.hidden = !isScheduled || (!this.selectedIso && !this.savedIso);
    }

    if (this.checkoutButton) {
      this.checkoutButton.disabled = isBlocking;
      this.checkoutButton.setAttribute('aria-disabled', isBlocking ? 'true' : 'false');
    }

    if (this.rebuyRoot) {
      this.getRebuyCheckoutTargets().forEach(function(target) {
        if ('disabled' in target) {
          target.disabled = isBlocking;
        }
        target.setAttribute('aria-disabled', isBlocking ? 'true' : 'false');
        target.classList.toggle('delivery-date-picker__checkout-disabled', isBlocking);
      });
    }

    if (this.confirmation) {
      if (isScheduled && this.selectedIso && !this.hasSaveError) {
        this.confirmation.textContent = (this.isSaving ? 'Saving requested delivery date: ' : 'Requested delivery date: ') + formatSlashDate(this.selectedIso);
        this.confirmation.classList.remove('is-empty');
        this.confirmation.setAttribute('aria-hidden', 'false');
        this.confirmation.hidden = false;
      } else {
        this.confirmation.textContent = 'Requested delivery date selected';
        this.confirmation.classList.add('is-empty');
        this.confirmation.setAttribute('aria-hidden', 'true');
        this.confirmation.hidden = false;
      }
    }

    if (this.error && !this.hasSaveError) {
      this.error.hidden = true;
      this.error.textContent = '';
    }
  };

  function initDeliveryDatePickers(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-delivery-date-picker]').forEach(function(element) {
      if (element.dataset[INITIALIZED]) {
        return;
      }

      element.dataset[INITIALIZED] = 'true';
      new Picker(element);
    });
  }

  function mountRebuyPicker() {
    var template = document.getElementById('DeliveryDatePickerTemplate');
    if (!template) {
      return;
    }

    var footer = document.querySelector('[data-rebuy-cart-anchor="footer"]');
    var checkoutArea = document.querySelector('[data-rebuy-component="checkout-area"]');
    var mount = footer || (checkoutArea ? checkoutArea.parentNode : null);

    if (!mount || mount.querySelector('[data-delivery-date-picker]')) {
      return;
    }

    var fragment = template.content.cloneNode(true);
    var picker = fragment.querySelector('[data-delivery-date-picker]');
    if (picker) {
      picker.classList.add('delivery-date-picker--rebuy');
    }

    if (checkoutArea && checkoutArea.parentNode === mount) {
      mount.insertBefore(fragment, checkoutArea);
    } else {
      mount.appendChild(fragment);
    }

    initDeliveryDatePickers(mount);
  }

  function watchForRebuyCart() {
    mountRebuyPicker();

    ['rebuy:smartcart.ready', 'rebuy:smartcart.show', 'rebuy:cart.change'].forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        window.setTimeout(mountRebuyPicker, 0);
      });
    });

    var attempts = 0;
    var poll = window.setInterval(function() {
      attempts += 1;
      mountRebuyPicker();

      if (attempts >= 20 || document.querySelector('[data-delivery-date-picker]')) {
        window.clearInterval(poll);
      }
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', function() {
    watchForRebuyCart();
    initDeliveryDatePickers(document);
  });

  document.addEventListener('cart:updated', function() {
    initDeliveryDatePickers(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initDeliveryDatePickers(event.target);
  });
})();
